<template>
  <div>
    <BreadCrumd :title="'Checklists'" :description="'Nouvelle checklist'" />
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="row d-flex justify-content-md-center">
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="nom"
                        >Nom checklist <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('nom') }"
                        id="nom"
                        v-model="form.nom"
                        type="text"
                        placeholder="Nom checklist"
                        maxlength="100"
                        required
                      />
                      <has-error :form="form" field="nom"></has-error>
                    </div>
                  </div>
                  <div class="col-md-2 col-lg-1 mt-3 pt-1">
                    <switches
                      text-enabled="Statut actif"
                      text-disabled="Statut inactif"
                      v-model="form.statut"
                      type-bold="true"
                      color="custom-primary"
                      class="ml-1 mb-0 font-size-17"
                    ></switches>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <b-alert
          :show="itemListErrorMessage !== null"
          dismissible
          variant="danger"
        >
          <span v-html="itemListErrorMessage"></span>
        </b-alert>
        <div class="row mt-n4">
          <div class="col-md-12">
            <table class="card table table-sm">
              <thead>
                <tr class="d-flex">
                  <th class="col-8">Libellé de la question</th>
                  <th class="col-2 text-center">Statut</th>
                  <th class="col-2 text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in form.item_lists"
                  :key="index"
                  class="d-flex"
                >
                  <td class="col-8" style="vertical-align: middle">
                    <input
                      class="form-control"
                      v-model="item.libelle"
                      type="text"
                      placeholder="Libellé de la question"
                      @focus="$event.target.select()"
                    />
                  </td>

                  <td class="col-2 text-center" style="vertical-align: middle">
                    <toggle-button
                      :width="width"
                      :height="height"
                      :font-size="font"
                      v-model="item.statut"
                      :labels="{ checked: 'Actif', unchecked: 'Inactif' }"
                      :color="{
                        checked: '#5CB85C',
                        unchecked: 'red',
                        disabled: '#CCCCCC',
                      }"
                    />
                  </td>

                  <td class="col-2 text-center" style="vertical-align: middle">
                    <a
                      v-if="index === 0"
                      class="cursor-pointer"
                      @click.prevent="addItem"
                    >
                      <i :class='create.ICON_PLUS' class="font-size-17 text-success"></i
                    ></a>
                    <a
                      v-else
                      class="cursor-pointer"
                      @click.prevent="removeItem(index)"
                    >
                      <i :class='create.ICON_TRASH' class="font-size-17 text-danger"></i
                    ></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <button
              type="button"
              class="btn btn-secondary mr-4"
              @click.prevent="
                $router.push({ name: 'gpao_checklist' }).catch(() => {})
              "
            >
              Liste des checklists
            </button>

            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Créer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL from '@/http/gpao/checklist';
import Form from 'vform';
import { create } from '@/icons/gpao/checklist'

export default {
  data() {
    return {
      create,

      form: new Form({
        nom: '',
        statut: true,
        item_lists: [{ libelle: '', statut: true }],
      }),
      width: 85,
      height: 30,
      font: 13,
      itemListErrorMessage: null,
      title: 'Gestion des checklists - Création',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    addItem() {
      this.form.item_lists.push({
        libelle: '',
        statut: true,
      });
    },
    removeItem(index) {
      this.form.item_lists.splice(index, 1);
    },
    submit() {
      this.itemListErrorMessage = null;

      this.form
        .post(URL.CHECKLIST)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          //this.init();
        })
        .catch((err) => {
          window._.forEach(err.response.data.errors, (value, key) => {
            if (key.includes('item_lists')) {
              this.itemListErrorMessage = value[0];
            } else {
              this.form.errors.set('message', err.response.data.message);
            }
            return 0;
          });
        });
    },
  },
};
</script>

<style scoped></style>
